var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.79 179.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#e30613;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.69,235.55a30.64,30.64,0,0,1-6.69,31c-10.55,11.67-42.92,21.91-61,21.91s-50.48-10.27-61-22a30.64,30.64,0,0,1-6.66-31s-31.94-16.7-20-55.32c10-32.31,75.35-44.31,79.65-68.63l8.1,3.34,8.11-3.33c4.28,24.32,69.63,36.37,79.6,68.69C299.64,218.87,267.69,235.55,267.69,235.55Z",
    transform: "translate(-108.11 -110.05)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.09,193.59c-1,24.79-45.79,33.84-45.79,33.84,5.73.95,12.4,8.11,11.92,22.89-.48,14.48-28.87,33.52-30.91,37.88-1.89.16-3.68.25-5.34.25s-3.46-.09-5.34-.26c-2-4.35-30.42-23.42-30.89-37.9-.47-14.78,6.21-21.93,11.93-22.88,0,0-44.81-9.08-45.76-33.87s14.8-32.89,29.1-32.89S184.75,175,200,175s26.7-14.29,41-14.29S271.05,168.8,270.09,193.59Z",
    transform: "translate(-108.11 -110.05)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.66,193.07c1.57-2.62,19.07,8.59,27.65,13.84s11.91,8.59,11.91,9.06,0,1.91-2.38,1.91-19.55-5.25-28.13-11.46S154.23,195.45,155.66,193.07Z",
    transform: "translate(-108.11 -110.05)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.34,193.1c-1.57-2.61-19.07,8.58-27.66,13.82s-11.92,8.58-11.92,9.06,0,1.9,2.38,1.9,19.55-5.23,28.14-11.43S245.77,195.49,244.34,193.1Z",
    transform: "translate(-108.11 -110.05)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.22,216c0,.48,0,1.91-2.38,1.91-1.38,0-7.67-1.75-14.4-4.42,0-.31-.06-.62-.08-.94,0-.51-.06-1-.06-1.56a21.63,21.63,0,0,1,1-6.52l4,2.47C191.89,212.16,195.22,215.5,195.22,216Z",
    transform: "translate(-108.11 -110.05)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.34,193.1c-1.57-2.61-19.07,8.58-27.66,13.82s-11.92,8.58-11.92,9.06,0,1.9,2.38,1.9,19.55-5.23,28.14-11.43S245.77,195.49,244.34,193.1Z",
    transform: "translate(-108.11 -110.05)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.16,225.5c4.77-1.9,22.41-2.37,27.18,0",
    transform: "translate(-108.11 -110.05)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.22,216c0,.48,0,1.91-2.38,1.91-1.38,0-7.67-1.75-14.4-4.42,0-.31-.06-.62-.08-.94,0-.51-.06-1-.06-1.56a21.63,21.63,0,0,1,1-6.52l4,2.47C191.89,212.16,195.22,215.5,195.22,216Z",
    transform: "translate(-108.11 -110.05)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.69,211q0,.78-.06,1.56,0,.47-.09.93c-6.72,2.67-13,4.41-14.4,4.41-2.38,0-2.38-1.43-2.38-1.9s3.34-3.82,11.92-9.06c1.19-.72,2.55-1.56,4-2.46A21.53,21.53,0,0,1,221.69,211Z",
    transform: "translate(-108.11 -110.05)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApis);
export default __webpack_public_path__ + "static/media/apis.dbce86c0e1abf8aee0aed9c96f78921c.svg";
export { ForwardRef as ReactComponent };